import "./ContactUs.css";
import contactImage from "../../assets/Contact-us.jpg";
import SubscripationPlanVeiwController from "../../redux/actions/SubscripationPlanAction";
import { useDispatch } from "react-redux";
import { Formik, Form, useField } from "formik";
import * as Yup from "yup";

const ContactUs = () => {
  const dispatch = useDispatch();
  const { addContactUsRequest } = SubscripationPlanVeiwController();

  // ✅ Formik custom input component
  const CustomInput = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    return (
      <div className="input-group">
        <input
          {...field}
          {...props}
          className={`form-input ${meta.touched && meta.error ? "error" : ""}`}
        />
        {meta.touched && meta.error && (
          <div className="error-message">{meta.error}</div>
        )}
      </div>
    );
  };

  const CustomTextArea = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    return (
      <div className="input-group">
        <textarea
          {...field}
          {...props}
          className={`form-input textarea ${
            meta.touched && meta.error ? "error" : ""
          }`}
        />
        {meta.touched && meta.error && (
          <div className="error-message">{meta.error}</div>
        )}
      </div>
    );
  };

  // ✅ Validation Schema
  const validationSchema = Yup.object({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    mobile_number: Yup.string()
      .matches(/^[0-9]+$/, "Mobile number must contain only digits")
      .optional(),
    message: Yup.string().required("Message is required")
  });

  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    message: ""
  };

  const handleSubmit = (values, { resetForm }) => {
    dispatch(addContactUsRequest(values));
    resetForm();
  };

  return (
    <div className="app-container">
      <div className="contactus-container">
        <div
          className="contactus-image"
          style={{ backgroundImage: `url(${contactImage})` }}
        >
          <h1>Get in Touch</h1>
          <p>
            Have questions or need support? We're here to help! Reach out to us
            and we'll get back to you as soon as possible.
          </p>
        </div>

        <div className="contactus-wrapper">
          <div className="contactus-form">
            <h2>Need help with payroll, tax filing or employee onboarding?</h2>
            <p>
              Fill in your details and our payroll experts will guide you with
              setup, automation, compliance and everything in between..
            </p>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="form-row">
                    <CustomInput
                      name="first_name"
                      placeholder="First Name*"
                      type="text"
                    />
                    <CustomInput
                      name="last_name"
                      placeholder="Last Name*"
                      type="text"
                    />
                  </div>

                  <CustomInput name="email" placeholder="Email*" type="email" />

                  <CustomInput
                    name="mobile_number"
                    placeholder="Mobile Number"
                    type="text"
                  />

                  <CustomTextArea
                    name="message"
                    placeholder="How can we help?"
                    rows="3"
                  />

                  <button  className="contact_button" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </Form>
              )}
            </Formik>
          </div>

          <div className="contactus-info">
            <h3>Talk to a Payroll Specialist</h3>
            <p>
              from salary processing to statutory compliance and reporting —
              we’re here to streamline your payroll operations..
            </p>
            <div className="info-box">
              <p>Send us an Email</p>
              <p className="email">support@thryiv.in</p>
              <button
              className="contact_button"
                onClick={() =>
                  (window.location.href =
                    "mailto:support@thryiv.in?subject=Payroll%20Support%20Request&body=Hi%20Team,%0D%0A%0D%0AI%20need%20assistance%20with...")
                }
              >
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
